import { render, staticRenderFns } from "./BookingUpdateView.vue?vue&type=template&id=b2c034c4&scoped=true"
import script from "./BookingUpdateView.vue?vue&type=script&lang=ts"
export * from "./BookingUpdateView.vue?vue&type=script&lang=ts"
import style0 from "./BookingUpdateView.vue?vue&type=style&index=0&id=b2c034c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2c034c4",
  null
  
)

export default component.exports